import ReferenceChips from '../references/ReferenceChips'
import { standardId, standardName } from '../../utils/standardRef'
import { Highlighted } from '../search'

// Renders text-search page hits: one block per page (standard + page + match
// count), highlighted snippet extracts, and the covering items as clickable
// chips (same look as chat references, with a See more/less toggle). Clicking a
// page header opens that page in the viewer; clicking a chip opens the item's
// start page.

function ResultRow({ result, onOpenPage, onOpenItem }) {
  return (
    <li className="ts-result">
      <button type="button" className="ts-result-head" onClick={() => onOpenPage(result)}>
        <span className="ts-result-standard" title={standardName(result.standard)}>
          {standardName(result.standard)}
        </span>
        <span className="ts-result-page">p.{result.page}</span>
        <span className="ts-result-count">
          {result.matchCount} match{result.matchCount === 1 ? '' : 'es'}
        </span>
      </button>

      <div className="ts-snippets">
        {result.snippets.map((snippet, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <p className="ts-snippet" key={i}>
            <Highlighted text={snippet.text} matches={snippet.matches} />
          </p>
        ))}
      </div>

      <ReferenceChips items={result.items} onOpenItem={onOpenItem} label="Sections" />
    </li>
  )
}

function ResultsList({ state, onOpenPage, onOpenItem, onLoadMore, loadingMore }) {
  if (state.status === 'idle') {
    return <div className="ts-results-status">Add rules and run to search the library.</div>
  }
  if (state.status === 'loading') {
    return <div className="ts-results-status">Searching…</div>
  }
  if (state.status === 'error') {
    return <div className="ts-results-status">{state.error || 'Search failed.'}</div>
  }
  if (!state.results.length) {
    return <div className="ts-results-status">No matches.</div>
  }

  return (
    <div className="ts-results">
      <ul className="ts-results-list">
        {state.results.map((result) => (
          <ResultRow
            key={`${standardId(result.standard)}-${result.page}`}
            result={result}
            onOpenPage={onOpenPage}
            onOpenItem={onOpenItem}
          />
        ))}
      </ul>
      {state.hasMore ? (
        <button
          type="button"
          className="ts-load-more"
          onClick={onLoadMore}
          disabled={loadingMore}
        >
          {loadingMore ? 'Loading…' : 'Load more'}
        </button>
      ) : null}
    </div>
  )
}

export default ResultsList
